export enum ToastTypes {
    Success = 'successfull',
    Danger = 'danger',
    Alert = 'alert',
    Info = 'info',
}
